export { CorporativoOnboardingWelcome } from "./CorporativoOnboardingWelcome";
